export const computeRmsFromTimeDomain = (data: ArrayLike<number>): number => {
  if (data.length === 0) {
    return 0;
  }

  let sum = 0;
  for (let index = 0; index < data.length; index += 1) {
    const sample = Number(data[index] || 0);
    sum += sample * sample;
  }

  return Math.sqrt(sum / data.length);
};

export const readAnalyserRms = (analyser: AnalyserNode): number => {
  const data = new Float32Array(analyser.fftSize);
  analyser.getFloatTimeDomainData(data);
  return computeRmsFromTimeDomain(data);
};

export type VoiceEndpointingConfig = {
  silenceMs: number;
  minUtteranceMs: number;
  maxUtteranceSeconds: number;
  vadRmsThreshold: number;
  bargeInRmsThreshold: number;
  bargeInHoldoffMs: number;
};

export const defaultVoiceEndpointing = (
  overrides?: Partial<VoiceEndpointingConfig>,
): VoiceEndpointingConfig => ({
  silenceMs: 650,
  minUtteranceMs: 280,
  maxUtteranceSeconds: 20,
  vadRmsThreshold: 0.015,
  bargeInRmsThreshold: 0.045,
  bargeInHoldoffMs: 400,
  ...overrides,
});
